export default __webpack_public_path__ + "static/media/groundPart11.12263e96.webp";